import React from "react";
import {
  Box,
  Typography,
  Stack,
  Tooltip,
  IconButton,
  CardContent,
} from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlineOutlined";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DateRangeIcon from "@mui/icons-material/DateRange";

import { StyledCard } from "../common/StyledCard";
import StatusChip from "../common/StatusChip";
import InfoRow from "../common/InfoRow";
import { AcademicYearResponseDto } from "../../shared/dtos/academicYear/AcademicYearResponseDto";

interface AcademicYearCardProps {
  academicYear: AcademicYearResponseDto;
  onEdit?: () => void;
  onDelete?: () => void;
}

const AcademicYearCard: React.FC<AcademicYearCardProps> = ({
  academicYear,
  onEdit,
  onDelete,
}) => {
  return (
    <StyledCard>
      <CardContent
        sx={{ p: 2, flexGrow: 1, display: "flex", flexDirection: "column" }}
      >
        {/* Header: Name and Actions */}
        <Stack
          direction="row"
          sx={{
            justifyContent: "space-between",
            alignItems: "flex-start",
            mb: 2,
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {academicYear.name}
          </Typography>
          <Stack direction="row">
            {onEdit && (
              <Tooltip title="Edit Academic Year">
                <IconButton size="small" color="secondary" onClick={onEdit}>
                  <EditOutlinedIcon />
                </IconButton>
              </Tooltip>
            )}
            {onDelete && (
              <Tooltip title="Delete Academic Year">
                <IconButton size="small" color="error" onClick={onDelete}>
                  <DeleteOutlineIcon />
                </IconButton>
              </Tooltip>
            )}
          </Stack>
        </Stack>

        {/* Body: Start & End Dates */}
        <Stack spacing={1.5} sx={{ flexGrow: 1 }}>
          <InfoRow
            icon={<CalendarMonthIcon fontSize="small" />}
            label="Start Date"
            value={academicYear.startDate}
          />
          <InfoRow
            icon={<DateRangeIcon fontSize="small" />}
            label="End Date"
            value={academicYear.endDate}
          />
        </Stack>

        {/* Footer: Status */}
        <Box sx={{ mt: 2, textAlign: "right" }}>
          <StatusChip status={academicYear.academicYearStatus} />
        </Box>
      </CardContent>
    </StyledCard>
  );
};

export default AcademicYearCard;
